import { getDongInfoAPI, getLeakDongMapAPI, getLeakUnitsAPI } from "@/apis/apt-api"
import { create } from "zustand"
import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { leakChartStore } from "./_components/leak/leak-chart-store"
import { analysisBundle } from "./analysis-const"

const isSameDong = (unitDong, selectedDong) => {
  if (selectedDong === "all") {
    return true
  }

  return Number(unitDong) === Number(selectedDong)
}

export const analysisStore = create((set, get) => ({
  originDongs: [],

  dongs: [],

  allLeakUnits: [],

  filteredLeakUnits: [],

  selectedDong: "all",

  dongCountMap: {},

  dongBadgesMap: null,

  setSelectedDong: (selectedDong) => {
    const { allLeakUnits } = get()

    const filteredLeakUnits =
      selectedDong === "all"
        ? allLeakUnits
        : allLeakUnits.filter((unit) => isSameDong(unit.dong, selectedDong))

    set({
      selectedDong,
      filteredLeakUnits
    })
  },

  dongMapping: (dongs) => {
    const { lang } = langStore.getState()

    const dongMaps = [
      {
        id: "all",
        label: analysisBundle.all[lang]
      },
      ...dongs.map((d) => ({
        id: d,
        label: formatMessage(analysisBundle.dong[lang], {
          dong: d
        })
      }))
    ]

    set({
      dongs: dongMaps
    })
  },

  apiGetDongs: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const { dongMapping } = get()

    const { dongs } = await getDongInfoAPI({
      sido,
      kapt_code
    })

    set({
      originDongs: dongs
    })

    dongMapping(dongs)
  },

  apiGetLeakUnits: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const result = await getLeakUnitsAPI({
      sido,
      kapt_code,
      dong: "all"
    })

    const { setLeakUnits } = leakChartStore.getState()

    const { leak_units } = result

    setLeakUnits(leak_units)

    const updateDongBadgesMap = {}

    leak_units.forEach((item) => {
      const dong = Number(item.dong)

      if (!updateDongBadgesMap[dong]) {
        updateDongBadgesMap[dong] = {
          dongBadges: {}
        }
      }

      updateDongBadgesMap[dong].dongBadges.leak =
        (updateDongBadgesMap[dong].dongBadges.leak || 0) + 1
    })

    set({
      allLeakUnits: leak_units,

      filteredLeakUnits: leak_units,

      dongBadgesMap: updateDongBadgesMap
    })

    return true
  },

  getFilteredLeakUnits: () => {
    const { allLeakUnits, selectedDong } = get()

    if (selectedDong === "all") {
      return allLeakUnits
    }

    return allLeakUnits.filter((unit) => isSameDong(unit.dong, selectedDong))
  },

  apiGetLeakDongMap: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const dongCountMap = await getLeakDongMapAPI({
      sido,
      kapt_code
    })

    set({
      dongCountMap
    })
  },

  reset: () => {
    set({
      originDongs: [],
      dongs: [],
      allLeakUnits: [],
      filteredLeakUnits: [],
      selectedDong: "all",
      dongCountMap: {},
      dongBadgesMap: {}
    })

    leakChartStore.getState().reset()
  }
}))
